export const APP_ROUTE_PATIENT_FORGOT_PASSWORD = '/patient/forgot'
export const APP_ROUTE_PATIENT_RESET_PASSWORD = '/patient/reset-password'
export const APP_ROUTE_PATIENT_INVITATION = '/patient/invitation'
export const APP_ROUTE_PATIENT_VERIFICATION = '/patient/verification'
export const APP_ROUTE_PATIENT_SUCCESS = '/patient/success'
export const APP_ROUTE_PATIENT_APPOINTMENTS = '/patient/appointments'
export const APP_ROUTE_PATIENT_MESSAGES = '/patient/messages'
export const APP_ROUTE_PATIENT_CHARTS = '/patient/charts'
export const APP_ROUTE_PATIENT_CHARTS_ARCHIVE = '/patient/charts-archive'
export const APP_ROUTE_PATIENT_RESULTS = '/patient/results'
export const APP_ROUTE_PATIENT_MEDICATIONS = '/patient/medications'
export const APP_ROUTE_PATIENT_SUPPORT = '/patient/support'
export const APP_ROUTE_PATIENT_LOGIN = '/patient/login'
export const APP_ROUTE_PATIENT_REGISTER = '/patient/register'
export const APP_ROUTE_PATIENT_PROFILE = '/patient/profile'
export const APP_ROUTE_PATIENT_SETTINGS = '/patient/settings'
export const APP_ROUTE_PATIENT_HELP = '/patient/help'
